import {
    GET_USER,
    GET_USER_SUCCESS,
    GET_USER_FAILURE,
    DELETE_USER,
    DELETE_USER_SUCCESS,
    DELETE_USER_FAILURE,
    EDIT_USER,
    EDIT_USER_SUCCESS,
    EDIT_USER_FAILURE,
    ADD_USER,
    ADD_USER_SUCCESS,
    ADD_USER_FAILURE,
    UPDATE_USER_STATUS,
    UPDATE_USER_STATUS_SUCCESS,
    UPDATE_USER_STATUS_FAILURE,
    GET_THEME,
    GET_THEME_SUCCESS,
    GET_THEME_FAILURE,
    GET_USER_SERVICES,
    GET_USER_SERVICES_SUCCESS,
    GET_USER_SERVICES_FAILURE,
    IMPORT_USER_DATA,
    IMPORT_USER_DATA_SUCCESS,
    IMPORT_USER_DATA_FAILURE,
    DOWNLOAD_CSV_USERS,
    DOWNLOAD_CSV_USERS_SUCCESS,
    DOWNLOAD_CSV_USERS_FAILURE
    
} from "../Constants";

export const GetUser = (payload) => ({
    type: GET_USER,
    payload
});

export const GetUserSuccess = (payload) => ({
    type: GET_USER_SUCCESS,
    payload
});

export const GetUserFailure = (payload) => ({
    type: GET_USER_FAILURE,
    payload
});

export const DeleteUser = (payload) => ({
    type: DELETE_USER,
    payload
});

export const DeleteUserSuccess = (payload) => ({
    type: DELETE_USER_SUCCESS,
    payload
});

export const DeleteUserFailure = (payload) => ({
    type: DELETE_USER_FAILURE,
    payload
});

export const EditUser = (payload) => ({
    type: EDIT_USER,
    payload
});

export const EditUserSuccess = (payload) => ({
    type: EDIT_USER_SUCCESS,
    payload
});

export const EditUserFailure = (payload) => ({
    type: EDIT_USER_FAILURE,
    payload
});

export const AddUser = (payload) => ({
    type: ADD_USER,
    payload
});

export const AddUserSuccess = (payload) => ({
    type: ADD_USER_SUCCESS,
    payload
});

export const AddUserFailure = (payload) => ({
    type: ADD_USER_FAILURE,
    payload
});

export const UpdateUserStatus = (payload) => ({
    type: UPDATE_USER_STATUS,
    payload
});

export const UpdateUserStatusSuccess = (payload) => ({
    type: UPDATE_USER_STATUS_SUCCESS,
    payload
});

export const UpdateUserStatusFailure = (payload) => ({
    type: UPDATE_USER_STATUS_FAILURE,
    payload
});

export const ImportData = (payload) => ({
    type: IMPORT_USER_DATA,
    payload
});

export const ImportDataDataSuccess = (payload) => ({
    type: IMPORT_USER_DATA_SUCCESS,
    payload
});

export const ImportDataDataFailure = (payload) => ({
    type: IMPORT_USER_DATA_FAILURE,
    payload
});

export const GetTheme = () => ({
    type: GET_THEME
});

export const GetThemeSuccess = (payload) => ({
    type: GET_THEME_SUCCESS,
    payload
});

export const GetThemeFailure = (payload) => ({
    type: GET_THEME_FAILURE,
    payload
});

export const GetUserServices = () => ({
    type : GET_USER_SERVICES
});

export const GetUserServicesSuccess = (payload) => ({
    type : GET_USER_SERVICES_SUCCESS,
    payload
});

export const GetUserServicesFailure = (payload) => ({
    type : GET_USER_SERVICES_FAILURE,
    payload
})

export const GetUserCsv = (payload) => ({
    type : DOWNLOAD_CSV_USERS,
    payload
})

export const GetUserCsvSuccess = (payload) => ({
    type : DOWNLOAD_CSV_USERS_SUCCESS,
    payload
})

export const GetUserCsvFailure = (payload) => ({
    type : DOWNLOAD_CSV_USERS_FAILURE,
    payload
})